import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { omit as _omit } from 'lodash';

import { changeUploadContext, resetUploadContext } from 'actions/UploadActions';
import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';
import { formatEntityErrorsForDisplay } from 'helpers/formStatus';

import Breadcrumb from 'components/layout/Breadcrumb';
import Tabs from 'components/layout/Tabs';
import CarData from 'components/layout/item/CarData';
import CarPrices from 'components/layout/item/CarPrices';
import ItemStockAndPrices from 'components/layout/item/ItemStockAndPrices';
import ItemData from 'components/layout/item/ItemData';
import ItemImages from 'components/layout/item/ItemImages';
import ItemAttributes from 'components/layout/item/ItemAttributes';
import PageLangSeo from 'components/layout/cms/PageLangSeo';
import ItemVariants from 'components/layout/item/ItemVariants';

import FormErrors from 'components/forms/FormErrors';
import { getNameInCurrentLanguage } from 'helpers/intl';
import ItemVariantsPrint from './ItemVariantsPrint';
import ProductTemplateCSS from '../productTemplate/ProductTemplateCSS';
import may from "js/security";
import ItemProvisionService from "components/layout/item/ItemProvisionService";
import ClientProvisionServiceList from "components/layout/client/ClientProvisionServiceList";
import ItemSurcharge from 'components/layout/item/ItemSurcharge';
class ItemView extends React.Component {
  constructor(props) {
    super(props);

    const { entity, entityLoaded, user, inModal } = props;

    this.state = {
      owner: entityLoaded &&
        entity.data &&
        entity.data.owner && {
          ...entity.data.owner,
          username: entity.data.owner.id,
        },
    };
  }

  updateOwner = (fieldName, owner) => {
    this.setState({ owner });
  };

  componentWillMount = () => {
    /* if (false) {
    } else { */
    const { itemId, updateUploadContext } = this.props;

    updateUploadContext({
      type: 'item_img',
      itemId,
      uploadLink: '/api/items/' + itemId + '/assets.json',
    });
    /* } */
  };

  componentWillUnmount = () => {
    const { doResetUploadContext } = this.props;
    doResetUploadContext();
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatus,
      doNotify,
      entity,
      entityLoaded,
      user,
      inModal
    } = this.props;

    // item data was saved and there was no error
    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      //      this.setState({ entityChanged: false })
      doNotify(1, messages.item_data_saved);
    }

    if (entityLoaded && !prevProps.entityLoaded && entity.data && entity.data.owner) {
      this.setState({ owner: { ...entity.data.owner, username: entity.data.owner.id } });
    }
  };

  formSubmit = e => {
    e.preventDefault();

    const { entity: beforeValidation, changeEntity } = this.props;

    changeEntity(beforeValidation.validate(), () => {
      const { itemId, entity: afterValidation, onSubmit, editItem } = this.props;
      const { owner } = this.state;

      if (afterValidation.isValid) {
        // check if we need to reset the model field
        const omit = ['slug'];
        if (editItem) {
          omit.push('model');
        }

        // this should be changed if we are using prices for multiple countries
        afterValidation.processedData.itemCountry = [
          { pricing: afterValidation.processedData.pricing, country: 'DE' },
        ];
        onSubmit(itemId, _omit({ ...afterValidation.processedData, owner }, omit));
      }
    });
  };

  getTabHeaderList = () => {
    const {
      intl: { messages },
      editItem,
      editPrintItem,
      editCar,
      user,
      entityLoaded,
      inModal
    } = this.props;
    const result = [];
    result.push(editCar ? messages.car : messages.item);
    result.push(messages.images);
    result.push(messages.attributes);
    if (editItem) {
      result.push(messages.variants);
      result.push(messages.stock_and_prices);
    } else if (editPrintItem) {
      result.push(messages.auflagen);
      result.push(messages.print_prices);
    } else {
      result.push(messages.prices);
    }
    result.push(messages.template_styles);
    result.push(messages.seo);

    if ((editItem || editPrintItem) && ((entityLoaded && may('ROLE_ADMIN', user.roles)) || may('ROLE_ROOT_EMPLOYEE', user.roles))) {
      result.push(messages.provision_service);
    }
    if (
      (editItem || editPrintItem) &&
      (((entityLoaded && may('ROLE_ADMIN', user.roles)) || may('ROLE_ROOT_EMPLOYEE', user.roles)) &&
        may('ROLE_PROVISION_VALID', user.roles))
    ) {
      result.push(messages.provision_service_documents);
    }

    if (
      (editItem || editPrintItem) &&
      (((entityLoaded && may('ROLE_ADMIN', user.roles)) || may('ROLE_ROOT_EMPLOYEE', user.roles)))
    ) {
      result.push(messages.financial);
    }

    return result;
  };

  getTabContentList = () => {
    const { editItem, editPrintItem, editCar, formStatus, entity, entityLoaded, changeEntity, user, editSelf, activeForms, inModal } = this.props;
    const { owner } = this.state;
    const result = [];

    const disabled = formStatus.pending || (!editSelf && !activeForms.allowEdit);
    const sharedProps = { entityLoaded, entity, changeEntity: this.changeEntity, disabled };

    if (editCar) {
      result.push(
        <CarData
          entityLoaded={entityLoaded}
          entity={entity}
          changeEntity={changeEntity}
          disabled={formStatus.pending}
          owner={owner}
          updateOwner={this.updateOwner}
        />
      );
    } else {
      result.push(
        <ItemData
          entityLoaded={entityLoaded}
          entity={entity}
          changeEntity={changeEntity}
          disabled={formStatus.pending}
          owner={owner}
          updateOwner={this.updateOwner}
          printItem={editPrintItem}
        />
      );
    }

    result.push(
      <ItemImages
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={changeEntity}
        disabled={formStatus.pending}
      />
    );
    result.push(
      <ItemAttributes
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={changeEntity}
        disabled={formStatus.pending}
        allowVariantAttributes={!editCar}
      />
    );
    if (editItem) {
      result.push(
        <ItemVariants
          itemEntityLoaded={entityLoaded}
          itemEntity={entity}
          changeEntity={changeEntity}
          disabled={formStatus.pending}
        />
      );
    } else if (editPrintItem) {
      result.push(
        <ItemVariantsPrint
          itemEntityLoaded={entityLoaded}
          itemEntity={entity}
          changeEntity={changeEntity}
          disabled={formStatus.pending}
        />
      );
    }
    if (editItem || editPrintItem) {
      result.push(
        <ItemStockAndPrices
          entityLoaded={entityLoaded}
          entity={entity}
          printItem={editPrintItem}
          changeEntity={changeEntity}
          disabled={formStatus.pending}
        />
      );
    } else {
      result.push(
        <CarPrices
          entityLoaded={entityLoaded}
          entity={entity}
          changeEntity={changeEntity}
          disabled={formStatus.pending}
        />
      );
    }
    result.push(
      <ProductTemplateCSS
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={changeEntity}
        disabled={formStatus.pending}
      />
    );
    result.push(
      <PageLangSeo
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={changeEntity}
        disabled={formStatus.pending}
      />
    );

    if ((editItem || editPrintItem) && ((entityLoaded && may('ROLE_ADMIN', user.roles)) || may('ROLE_ROOT_EMPLOYEE', user.roles))) {
      result.push(<ItemProvisionService key="serviceTypes" {...sharedProps} item={entity} />);
    }
    if (
      (editItem || editPrintItem) &&
      (((entityLoaded && may('ROLE_ADMIN', user.roles)) || may('ROLE_ROOT_EMPLOYEE', user.roles)) &&
        may('ROLE_PROVISION_VALID', user.roles))
    ) {
      result.push(<ClientProvisionServiceList key="provisionServiceList" {...sharedProps} item={entity} />);
    }

    if (
      (editItem || editPrintItem) &&
      (((entityLoaded && may('ROLE_ADMIN', user.roles)) || may('ROLE_ROOT_EMPLOYEE', user.roles)))
    ) {
      result.push(
        <Col xs={12} md={inModal ? 12 : 4}>
          <ItemSurcharge
            inModal={inModal}
            entity={entity}
            changeEntity={changeEntity}
            disabled={disabled}
          />
        </Col>
      );
    }

    return result;
  };

  getTabKeepMounted = () => {
    const { editItem } = this.props;
    const keepMounted = [2];
    if (editItem) {
      keepMounted.push(3);
    }
    return keepMounted;
  };

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
      breadcrumb,
      crumbs: parentCrumbs,
      entityLoaded,
      entity,
    } = this.props;

    if (breadcrumb) {
      return breadcrumb;
    }

    let itemHeader;
    if (entityLoaded) {
      const itemName =
        typeof entity.getName() === 'object' ? getNameInCurrentLanguage(entity.getName(), appIntl) : entity.getName();
      itemHeader = itemName;
    }

    if (parentCrumbs) {
      const crumbs = parentCrumbs.slice();
      crumbs.push({ link: null, name: itemHeader });

      return <Breadcrumb crumbs={crumbs} />;
    }

    return (
      <Breadcrumb
        crumbs={[
          { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
          { link: appIntl.urlPrefix + 'account/items', name: messages.items },
          { link: null, name: itemHeader },
        ]}
      />
    );
  };

  render() {
    const {
      intl: { messages },
      formStatus,
      entity,
      entityChanged,
      user
    } = this.props;

    return (
      <div class="padding-25 sm-padding-10">
        <FormErrors formStatus={formStatus} additionalErrors={formatEntityErrorsForDisplay(entity, messages)} />

        <form method="put" onSubmit={this.formSubmit}>
          {this.getBreadcrumb()}

          <Row>
            <Col xs={12}>
              <div class="text-right m-b-10">
                <Button
                  bsSize="lg"
                  disabled={formStatus.pending}
                  type="submit"
                  bsStyle={entityChanged ? 'primary' : 'default'}
                >
                  <i class={'fa-fw ' + (formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
                  {messages.save}
                </Button>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Tabs
                tabs={this.getTabHeaderList()}
                tabContent={this.getTabContentList()}
                keepMounted={this.getTabKeepMounted()}
              />
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}
ItemView.defaultProps = {
  editItem: false,
  editCar: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    formStatus: state.formStatus.itemEdit,
    user: state.login.user,
    activeForms: state.activeForms,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateUploadContext: newContext => {
      dispatch(changeUploadContext(newContext));
    },
    doResetUploadContext: () => {
      dispatch(resetUploadContext());
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    onSubmit: (itemId, args) => {
      formStatusDispatchHelper('itemEdit', '/api/items/' + itemId + '.json', args, 'put', dispatch);
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ItemView)
  )
);
